export default __webpack_public_path__ + "static/image4-64fdb5a2ffb267651cc0dba332ba8318.jpg";